import Row from 'src/frontend-common/components/Row';
import { ArrowForward } from '@mui/icons-material';
import { styled, SvgIconProps } from '@mui/material';
import * as React from 'react';
import { Alignment } from 'src/frontend-common/dto/Types/UIType';

interface PropTypes {
  hAlign?: Alignment;
  title: string;
  bold: string;
  onClick: () => void;
  withIcon?: boolean;
  Icon?: SvgIconProps;
}

const BottomAction: React.FC<PropTypes> = ({ hAlign = 'flex-start', title, bold, onClick, withIcon = false, Icon = <ArrowForward /> }) => {
  return (
    <Row hAlign={hAlign} vAlign="center">
      <div>
        {title}
        <LoginButton style={{ color: 'black' }} onClick={onClick}>
          <>
            {bold} {withIcon && Icon}
          </>
        </LoginButton>
      </div>
    </Row>
  );
};

export default BottomAction;

const LoginButton = styled('span')(({ theme }) => ({
  margin: `${theme.spacing(1)} 4px`,
  textTransform: 'none',
  textDecoration: 'none',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  '&:hover': { textDecoration: 'none', color: '#391041' },
}));
